"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const General_1 = require("../../types/General");
const getValueByPathFromUnknown_1 = __importDefault(require("../../shared/getValueByPathFromUnknown"));
const callableBuildCodeCompute = () => {
    const cacheOfFunctions = {};
    const getFunctionFromCache = (completeCode) => {
        if (!(0, ts_validators_1.valueIsString)(completeCode)) {
            return 'Validation: Code is not a string';
        }
        const functionInCache = cacheOfFunctions[completeCode];
        if (functionInCache) {
            return functionInCache;
        }
        if (completeCode.includes('console.')) {
            return 'Validation: Code cannot contain console.*';
        }
        if (completeCode.includes('require(')) {
            return 'Validation: Code cannot contain require(';
        }
        if (completeCode.includes('import')) {
            return 'Validation: Code cannot contain import';
        }
        if (completeCode.includes('export')) {
            return 'Validation: Code cannot contain export';
        }
        if (completeCode.includes('process.')) {
            return 'Validation: Code cannot contain process.*';
        }
        if (completeCode.includes('global.')) {
            return 'Validation: Code cannot contain global.*';
        }
        if (completeCode.includes('window.')) {
            return 'Validation: Code cannot contain window.*';
        }
        if (completeCode.includes('document.')) {
            return 'Validation: Code cannot contain document.*';
        }
        if (completeCode.includes('fetch(')) {
            return 'Validation: Code cannot contain fetch(';
        }
        if (completeCode.includes('XMLHttpRequest')) {
            return 'Validation: Code cannot contain XMLHttpRequest';
        }
        if (completeCode.includes('await ')) {
            return 'Validation: Code cannot contain await';
        }
        if (completeCode.includes('alert(')) {
            return 'Validation: Code cannot contain alert(';
        }
        if (completeCode.includes('apphive')) {
            return 'Validation: Code cannot contain the word apphive';
        }
        if (completeCode.length > 3000) {
            return 'Validation: Code cannot be longer than 3000 characters';
        }
        const wrappedCode = `const codeCompute = (args) => {${completeCode}}; return codeCompute;`;
        try {
            // eslint-disable-next-line no-new-func
            const codeComputeFunction = (new Function(wrappedCode))();
            cacheOfFunctions[completeCode] = codeComputeFunction;
            return codeComputeFunction;
        }
        catch (error) {
            const errorMessage = (0, getValueByPathFromUnknown_1.default)(error, ['message']);
            return `${errorMessage}`;
        }
    };
    return ({ entryVars: { [General_1.DEFINITION_PROP_NAMES.CODE]: code, [General_1.DEFINITION_PROP_NAMES.ARGS]: args, }, processor, }) => {
        const codeFunction = getFunctionFromCache(code);
        if ((0, ts_validators_1.valueIsString)(codeFunction)) {
            processor.root.alert('codeCompute Error', codeFunction);
            return undefined;
        }
        return codeFunction(args);
    };
};
exports.default = callableBuildCodeCompute;
